<div class="feature-container">
    <div class="feature-content container">
        <div class="feature-header">
            <div class="left-section">
                <p class="feature-title font-poppins">Featured Block Collection</p>
                <p class="feature-subtitle">Discover our most colorful and creative building sets</p>
            </div>

            <a routerLink="/products" [queryParams]="{ category: 'feature' }" class="right-section">
                <p class="view-all">View All</p>
                <mat-icon [svgIcon]="'rightarrow'" class="right-arow-icon"></mat-icon>
            </a>
        </div>
        <div class="feature-products">
            @for (product of featuredProducts; let i = $index; track i) {
            <app-product-card
                [product]="product"
                class="card"
                [imageBgClass]="'product-image-gradient' + ((i % 3) + 1)"
            ></app-product-card>
            }
        </div>
    </div>
</div>
